// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fEmg5vsWdgMYBaemGo7O{justify-content:space-between;align-items:center;gap:12px;width:100%;display:flex}.fEmg5vsWdgMYBaemGo7O .Q5dodXRh_ZUPl9hN_4Bw{align-items:center;display:flex}.fEmg5vsWdgMYBaemGo7O .c7XDyKqyCJsOGITwtP6p{gap:8px;display:flex}.v8ZhE7_cL0mvaKhU3gHo{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `fEmg5vsWdgMYBaemGo7O`,
	"flex": `Q5dodXRh_ZUPl9hN_4Bw`,
	"row8": `c7XDyKqyCJsOGITwtP6p`,
	"record": `v8ZhE7_cL0mvaKhU3gHo`
};
export default ___CSS_LOADER_EXPORT___;
